import { render } from "./ProfilePictureGalleryModal.vue?vue&type=template&id=71cb42c0&scoped=true&ts=true"
import script from "./ProfilePictureGalleryModal.vue?vue&type=script&lang=ts"
export * from "./ProfilePictureGalleryModal.vue?vue&type=script&lang=ts"

import "./ProfilePictureGalleryModal.vue?vue&type=style&index=0&id=71cb42c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71cb42c0"]])

export default __exports__